import React, { useState } from 'react'
import { Formik, Field, Form } from 'formik';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { useParams } from 'react-router-dom';
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();


const ResetPasswordForm = ({ product }) => {

    const history = useHistory();
    let { token } = useParams();

    return (
        <Formik
            initialValues={{
                password: '',
                confirmPassword: ''
            }}
            validate={values => {

                const errors = {};

                if (!values.password) {
                    errors.password = 'Password is Required';
                } else if (values.password.length < 6) {
                    errors.password = 'Password must be greater than 6 characters.';
                }
                if (values.password && values.confirmPassword && (values.password !== values.confirmPassword)) {
                    errors.password = 'Passwords do not match';
                }

              
                console.log(errors);
                return errors;

            }}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                const postData = { ...values, product: product, token: token };
                const res = await axios.post('https://evalexpert.io/v1/updatepass', postData);
                const data = res.data;
                if (data[0].password === "Updated") {
                    history.push("/insightsdashboard/pages/dashboard/signin");
                } 
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
            }) => (
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                            Password
                        </label>
                        <div className="mt-1">
                            <input
                                id="password"
                                name="password"
                                type="password"
                                autoComplete="password"
                                placeholder="Password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                                className={
                                    errors.password && touched.password ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                        : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                }
                            />
                            <p className="text-sm text-red-600" id="password-error">
                                {errors.password && touched.password && errors.password}
                            </p>
                        </div>
                    </div>

                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                            Confirm Password
                        </label>
                        <div className="mt-1">
                            <input
                                id="confirmPassword"
                                name="confirmPassword"
                                type="password"
                                autoComplete="confirmPassword"
                                placeholder="Confirm Password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.confirmPassword}
                                className={
                                    errors.password && touched.password ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                        : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                }
                            />
                            <p className="text-sm text-red-600" id="password-error">
                                {errors.password && touched.password && errors.password}
                            </p>
                        </div>
                    </div>

                    <div>
                        <button
                            type="submit"
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                            disabled={isSubmitting}
                        >
                            Reset
                        </button>
                    </div>
                    <p className="mt-2 text-sm text-gray-700">
                        Know your password? <p className="cursor-pointer text-sm text-gray-800 inline font-medium" onClick={() => history.push('/signin')}>Sign In</p>
                    </p>
                </form>
            )}
        </Formik>
    )
}

export default ResetPasswordForm
